import { Drawer } from '@halo/ui-react';
import { Center, Text } from '@chakra-ui/react';
import { CloseIcon } from '@halo/ui-chat-react';
import { useActionsStore } from '@/store/actions';
import ReportForm from './ReportForm.tsx';

function Index() {
  const logReportOpen = useActionsStore((set) => set.logReportOpen);
  const onLogReportOpenChange = useActionsStore((set) => set.onLogReportOpenChange);

  const { t } = useTranslation();

  return (
    <Drawer.Root
      open={logReportOpen}
      onOpenChange={(e) => onLogReportOpenChange(e.open)}
      lazyMount
      unmountOnExit
    >
      <Drawer.Positioner boxSize="full">
        <Drawer.Content bg="bg.subtle" w="456px" flex="0 0 auto" maxW="none">
          <Drawer.Header justifyContent="space-between" py="2.5" px="4" pt="5">
            <Text fontSize="md" fontWeight="semibold">
              {t('profile.logReport')}
            </Text>
            <Drawer.CloseTrigger asChild pos="relative" right="0" top="0">
              <Center fontSize="md" cursor="pointer" color="fg.subtle">
                <CloseIcon />
              </Center>
            </Drawer.CloseTrigger>
          </Drawer.Header>
          <Drawer.Body className="scrollHover" px="4" py="2.5">
            <ReportForm />
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  );
}

export default Index;
